module.exports = __webpack_public_path__ + "media/volvo/assets/images/stars-ab03fd68ca46f9ab5c1466770f8aa7e8.jpg";